module.exports = __webpack_public_path__ + "static/eduHeader-f6ae13f77f42eace5346dc879c0ff853.svg";